export enum DelegationsStorageKey {
  ADD_DELEGATION_FORM = 'add-delegation-form',
}
